export default function formatAmountPayload(
  stringAmount: string,
  modifier: number = 100,
) {
  return +stringAmount.replaceAll(',', '') * modifier;
}
